import { Checkbox, EventHandler } from "client/CommonComponents"
import { AttributeName, CONSTANTS } from "client/utils/constants"
import './index.scss';

const ExistingList = (props: any) => {
    const { ExistingDropDownValue = [], removeItem, filterName, catalogItemValues } = props
    return (
        <>
            {ExistingDropDownValue?.length ? <ul className='added-vehicle-level-list mt-0'>
                {ExistingDropDownValue?.map((item: any, index: any) => (
                    <li
                        key={index}
                        className={"todo-list__list-item"}
                    >
                        <div className= {`item vehicle_classname ${filterName == AttributeName.CLASS_TYPE ? "addnewwidth":""}`} title={item?.text}>{item?.text}</div>
                        {
                            (filterName == AttributeName.CLASS_TYPE && catalogItemValues?.vehicleType?.label == CONSTANTS.PRODUCTION_VEHICLE)   ?
                                <div className="row">                                
                                        <Checkbox className="mb-0 checkboxName col-2 checkbox-size" checked={!!item?.selected} disabled={true}  data-attribute="index_Default_Checkbox_3" />                                    
                                    <div className="col-10">
                                        <p>Show Vehicle Capacity</p>
                                    </div>
                                </div>
                                : null
                        }
                        <EventHandler onEvent={() => removeItem(item, index)} data-attribute="index_Default_EventHandler_17">
                            <span className="fa fa-trash-o delete-icon"></span>
                        </EventHandler>
                    </li>
                ))}
            </ul> : ''}
        </>
    )
}

export default ExistingList